<template>
  <div>
    <v-menu
      ref="patientMenu"
      v-model="patientMenu"
      :close-on-content-click="false"
      :nudge-right="40"
      :return-value.sync="patientData"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
      >
      <template v-slot:activator="{ on }">
        <v-text-field
          :value="patientData"
          label="Patientendaten"
          readonly
          required
          clearable
          v-on="on"
          >
          <template v-slot:prepend>
            <fa-icon icon="user-injured"></fa-icon>
          </template>
        </v-text-field>
      </template>
      <v-card>
        <v-card-text>
          <v-menu
            ref="dateMenu"
            v-model="dateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="bod"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="bod | moment('DD.MM.YYYY')"
                label="Geburtsdatum*"
                prepend-inner-icon="event"
                readonly
                required
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="bod"
              no-title
              scrollable
              locale="de"
              first-day-of-week="1"
            >
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="dateMenu = false">Abbrechen</v-btn>
              <v-btn flat color="primary" @click="$refs.dateMenu.save(bod)">OK</v-btn>
            </v-date-picker>
          </v-menu>

          <v-radio-group v-model="gender" row>
            <!--
            <template v-slot:label>
              <div>Geschlecht</div>
            </template>
            -->
            <v-radio label="Weiblich" value="f"></v-radio>
            <v-radio label="Männlich" value="m"></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="patientMenu = false">Abbrechen</v-btn>
          <v-btn flat color="primary" @click="$refs.patientMenu.save(patientData)">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
    <!--
    <v-overflow-btn
      label="Patientdaten (Alter / Geschlecht)"
      ></v-overflow-btn>
      https://demos.creative-tim.com/vuetify-material-dashboard/documentation/component-docs/dropdown.html
    -->
    <!--
    <v-select
      label="Patientdaten (Alter / Geschlecht)"
      v-model="patientData"
      >
      <template v-slot:item="{ item, tile }">
      </template>
    </v-select>
    -->
    <!--
      value="19.08.1981 / weiblich"
    -->
    <!--
    <v-text-field
      label="Patientdaten (Alter / Geschlecht)"
      clearable
      readonly
      type="text"
      append-icon="edit"
      @click:append="edit"
      >
    </v-text-field>
    <v-dialog v-model="dialog" max-width="600px">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        >
        <v-card>
          <v-card-title>
            <span class="headline">Patientendaten bearbeiten</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs6>
                  <v-menu
                    ref="dateMenu"
                    v-model="dateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="bod"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="bod | moment('DD.MM.YYYY')"
                        label="Datum*"
                        prepend-inner-icon="event"
                        readonly
                        required
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="bod"
                      no-title
                      scrollable
                      locale="de"
                      first-day-of-week="1"
                    >
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="dateMenu = false">Abbrechen</v-btn>
                      <v-btn flat color="primary" @click="$refs.dateMenu.save(bod)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12>
                  select field
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="close">Abbrechen</v-btn>
            <v-btn color="primary" flat @click="save" :disabled="!valid">Speichern</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    -->
  </div>
</template>

<script>
  
export default {
  props: {
    selectedVersion: {
      type: String,
      default: "01.09"
    }
  },
  data() {
    return {
      bod: "1981-08-19",
      gender: null,
      dateMenu: false,
      dialog: false,
      valid: true,
      patientData: "19.08.1981 / weiblich",
      patientMenu: false,
      version: this.selectedVersion,
      versions: [
        { text: "01.09", value: "01.09" },
        { text: "01.08.01_BR", value: "01.08.01_BR" }
      ]
    }
  },

  watch: {
    version(version) {
      this.$emit("change-version", version)
    }
  },

  methods: {
    close() {
      this.dialog = false
    },

    edit() {
      this.dialog = true
    },

    save() {
      console.log("save", this.bod, this.gender)
    }
  }
}
</script>

<style scoped>
</style>
